import { useState, useEffect } from "react";
import { IProduct } from "$containers";

const useProduct = (product: IProduct, resetProduct?: any) => {
  const [open, setOpen] = useState<boolean>(false);
  const [subProduct, setSubProduct] = useState<IProduct | undefined>(undefined);

  const togglePopin = (isOpen: boolean, force?: boolean) => {
    if (force) {
      setOpen(isOpen);
    } else if (!isOpen) {
      if (subProduct) {
        setSubProduct(undefined);
      } else if (resetProduct && !subProduct) {
        resetProduct();
      }
    } else {
      setOpen(isOpen);
    }
  };

  useEffect(() => {
    if (product?._id) {
      setOpen(true);
    }
  }, [product?._id]);

  return {
    open,
    setOpen,
    togglePopin,
    subProduct,
    setSubProduct,
  };
};

export default useProduct;
